import { connect } from 'react-redux';

import ImportManager from '../../components/ImportManager';

export default connect()(ImportManager);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportManager/index.tsx